import React, { useState } from 'react';
import { Link } from '@material-ui/core';
import { LEGAL_TERMS_URL } from '../../index';

const TerminosCondiciones : React.FC = () => {

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()
        window.open(LEGAL_TERMS_URL, '_blank');
    };

    return (
        <React.Fragment>
            Acepto <Link onClick={handleClick}>{'términos y condiciones'}</Link> del servicio
        </React.Fragment>
    )
}

export default TerminosCondiciones;